export enum ThemeRegistration {
  ThemeDefaultUx,
  ThemeDefaultUxDark,
  ThemeFach,
  ThemeFachDark,
  ThemeFachPrint,
  ThemeGray,
  ThemeGrayDark,
}
